module.exports = __webpack_public_path__ + "img/tiktok.ea305de7.svg";